<template>
  <div>
    <p>Drill down into individual endpoint instances for detailed performance analysis:</p>
    <ul>
      <li><strong>Instance-level metrics</strong> - See performance data for each running instance</li>
      <li><strong>Compare instances</strong> - Identify performance variations between instances</li>
      <li><strong>Resource utilization</strong> - Understand how each instance is handling its workload</li>
      <li><strong>Scaling insights</strong> - Make informed decisions about scaling your endpoints</li>
    </ul>
  </div>
</template>
